export { toBooleanFromBit } from '../../product/utils/productHelpers';

export const sortSectionRows = (rows = []) =>
  [...rows].sort(
    (a, b) =>
      Number(a.DisplayOrder || 0) - Number(b.DisplayOrder || 0) ||
      Number(a.ProductHomePageSectionId || 0) - Number(b.ProductHomePageSectionId || 0),
  );

export const getNextDisplayOrder = (rows = []) => {
  if (!rows.length) return 1;
  return Math.max(...rows.map((row) => Number(row.DisplayOrder) || 0)) + 1;
};